// =============================================================================
//  Copyright : 2018 semantics GmbH
//  Date      : $Date: 2020-03-28 01:42:16 +0100 (Sat, 28 Mar 2020) $
//  Author    : Albert Charlier, Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 109093 $
//  Purpose   : navigation elements
// =============================================================================
// ---Third-party imports
import React, {Component, useState} from 'react'

// ---Framework imports
import {Actions, Sel} from 'uix/registries'
import {get, dict, size, mapItems, filterItems, strip, flatten} from 'ldash'
import {Part, funcPart} from 'uix/parts'
import log from 'uix/logging'
import {decodeType, findElement, findElements} from 'uix/utils'
import {useSelector, useEffect, useActions, useInterval} from 'uix/hooks'
import {hashObj} from 'uix/utils'
import ustyles from 'uix/styles'

// ---Local imports
import './slider.scss'
import {HeaderSliderProto} from './heroSlider'
import {useWidgetData} from './hooks'

// ---Export
export {SwiperViewer} from './swiperViewer'

// ---Globals

let readStoryFromWikiPool = poolwiki => {
  let cfg = findElement(poolwiki, e => e.$tag == 'Widget')
  if (!cfg) {
    // <part> form
    cfg = findElement(poolwiki, e => e.$tag == 'part' && e['type'] == 'widget')
    if (!cfg) {
      return null
    }
    cfg = dict(mapItems(cfg, (name, value) => [name, decodeType(value)]))
  }
  let width = cfg.itemWidth || cfg.width
  let height = cfg.itemHeight || cfg.height || 250

  let poolId = parseInt(poolwiki.otid)
  // collect and build items
  let poolItems = findElements(
    poolwiki,
    e =>
      e.$tag == 'p' &&
      size(e.$children) > 0 &&
      ['Slider', 'Teaser', 'Item'].includes(e.$children[0].$tag)
  )

  //~ poolItems = poolItems.filter(e => size(e.$children) > 0 && e.$children[0]['data-vl-1'])
  let items = poolItems.map((widgetItem, i) => {
    let data = widgetItem.$children[0]
    //~ log('%o', data)
    let itemFormat = data.$tag.toLowerCase()

    let pageId = data.arg1
    // children[1] is an eventual <br/>
    let description = widgetItem.$children
      .slice(1)
      .map(e => strip(e.$tail))
      .join(' ')

    return {
      id: `${pageId}_${i}`,
      src: pageId ? `/image/serveTeaserCache/${poolId}?pageid=${pageId}&width=${width}` : null,
      width,
      height,
      description,
    }
  })

  return {cfg, items}
}

const PageResolver = ({data}) => {
  let otids = data.map(e => e.otid)
  // resolves page dimensions and mini titleinfo for ancestor (or self) md record
  let wdata = useWidgetData(otids)
  if (size(wdata) == 0) {
    return null
  }
  let otid2wdata = dict(
    otids.map(otid => {
      let {datatype, width, height, md_caption} = get(wdata, otid, {})
      if (!(datatype === 3)) {
        log.error('no page type')
        return [otid, null]
      }
      height = parseInt((304 / width) * height)
      width = 304

      md_caption = md_caption || ''
      return [
        otid,
        {
          pageId: otid,
          width: width,
          height: height,
          crop: '103%',
          header: md_caption.slice(0, 50),
        },
      ]
    })
  )

  let sliderData = data
    .filter(d => otid2wdata[d.otid])
    .map(({otid, description}) => {
      let wd = otid2wdata[otid]
      return {...wd, description}
    })
  if (sliderData.length > 2) {
    return <HeaderSliderProto data={sliderData} />
  }
  return null
}

export const Widget = funcPart(({poolwiki, partcfg}) => {
  let {rendered} = useSelector(root => root.data.wiki.preview)

  let story = {
    cfg: {format: partcfg.format},
    items: [],
  }

  // XXX: why should we do this? this kills poolwiki
  //~ if (rendered) {
  // intercept wiki-preview, and hack into poolwiki
  //~ poolwiki = {...poolwiki, $children: rendered}
  //~ }
  if (poolwiki && !poolwiki.missing) {
    story = readStoryFromWikiPool(poolwiki)
  }

  let format = story.cfg.format

  if (true) {
    let sliderData = story.items.map(({description, src, width, height}) => ({
      pageId: src.split('pageid=').slice(-1)[0],
      width: parseInt(width),
      height: parseInt(height),
      src,
      description,
    }))
    return <HeaderSliderProto data={sliderData} />
  } else if (true || format == 'showcase') {
    let data = story.items.map(({description, src}) => ({
      otid: src.split('pageid=').slice(-1)[0],
      description,
    }))
    return <PageResolver data={data} />
  } else {
    // probably format == 'slider'
    return <Carousel story={story} />
  }
})
